import { z } from "zod";
const automationRunIdSchema = z.uuid().brand();
function asAutomationRunId(id) {
  return automationRunIdSchema.parse(id);
}
const allAutomationRunStatuses = [
  "pending",
  "running",
  "succeeded",
  "failed",
  "canceled"
];
const automationRunStatusSchema = z.enum(allAutomationRunStatuses);
const TERMINAL_AUTOMATION_RUN_STATUSES = /* @__PURE__ */ new Set(["succeeded", "failed", "canceled"]);
export {
  TERMINAL_AUTOMATION_RUN_STATUSES,
  allAutomationRunStatuses,
  asAutomationRunId,
  automationRunIdSchema,
  automationRunStatusSchema
};
//# sourceMappingURL=automationRun.js.map
